import React, { useEffect, useState } from "react";
import AppShell from "../../components/layout/AppShell";
import { api, formatApiError } from "../../lib/api";
import { toast } from "sonner";

function fmtH(ms) {
  if (!ms || ms < 0) return "0h";
  return (ms / 3_600_000).toFixed(1) + "h";
}
function today() { return new Date().toISOString().slice(0, 10); }

export default function OfficeAttendance() {
  const [date, setDate] = useState(today());
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/attendance/today?date=${date}`).then(r => setData(r.data))
      .catch(e => toast.error(formatApiError(e)));
  }, [date]);

  const rows = data?.rows || [];
  const present = rows.filter(r => r.status !== "ABSENT").length;
  const onDuty = rows.filter(r => r.status === "ON_DUTY").length;
  const absent = rows.filter(r => r.status === "ABSENT").length;

  return (
    <AppShell title="Attendance & Time Tracking" subtitle="Staff Management"
      actions={
        <input type="date" value={date} onChange={e => setDate(e.target.value)}
               data-testid="attendance-date"
               className="h-10 px-3 border border-[#E5E2D9] rounded-md text-sm"/>
      }>
      <div className="grid grid-cols-4 gap-3 mb-4" data-testid="attendance-stats">
        <Stat label="Total" value={rows.length}/>
        <Stat label="On Duty" value={onDuty} color="#2D5A27"/>
        <Stat label="Present" value={present}/>
        <Stat label="Absent" value={absent} color="#C25D38"/>
      </div>

      <div className="bg-white border border-[#E5E2D9] rounded-md">
        <table className="w-full text-sm" data-testid="attendance-table">
          <thead>
            <tr className="bg-[#F7F6F2] text-left text-[11px] uppercase tracking-[0.2em] text-[#5C5A55]">
              <th className="px-6 py-3">Staff</th>
              <th className="px-6 py-3">Code</th>
              <th className="px-6 py-3">Role</th>
              <th className="px-6 py-3">Status</th>
              <th className="px-6 py-3 text-right">Sessions</th>
              <th className="px-6 py-3 text-right">Active</th>
              <th className="px-6 py-3 text-right">Break</th>
              <th className="px-6 py-3 text-right">Idle</th>
              <th className="px-6 py-3 text-right">Total</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={9} className="px-6 py-12 text-center text-[#8A8780]">No staff.</td></tr>}
            {rows.map((r, i) => (
              <tr key={r.user_id} className={i % 2 === 0 ? "bg-white" : "bg-[#FAFAF7]"}>
                <td className="px-6 py-3 font-medium">{r.name}</td>
                <td className="px-6 py-3 font-mono text-xs">{r.staff_code || "—"}</td>
                <td className="px-6 py-3 capitalize text-xs">{r.role}</td>
                <td className="px-6 py-3">
                  <span className={`px-2 py-0.5 rounded text-[10px] uppercase tracking-[0.18em] ${
                    r.status === "ON_DUTY" ? "bg-[#2D5A27] text-white" :
                    r.status === "ABSENT" ? "bg-[#F4C7B9] text-[#7A2E18]" :
                    "bg-[#D4E0D1] text-[#1A3317]"
                  }`}>{r.status}</span>
                </td>
                <td className="px-6 py-3 text-right font-mono">{r.sessions}</td>
                <td className="px-6 py-3 text-right font-mono text-[#2D5A27]">{fmtH(r.active_ms)}</td>
                <td className="px-6 py-3 text-right font-mono">{fmtH(r.break_ms)}</td>
                <td className="px-6 py-3 text-right font-mono text-[#C25D38]">{fmtH(r.inactive_ms)}</td>
                <td className="px-6 py-3 text-right font-mono font-semibold">{fmtH(r.total_ms)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </AppShell>
  );
}

const Stat = ({ label, value, color }) => (
  <div className="bg-white border border-[#E5E2D9] rounded-md p-4">
    <div className="text-[10px] uppercase tracking-[0.2em] text-[#8A8780]">{label}</div>
    <div className="font-heading text-3xl mt-1" style={{ color: color || "#1A1A1A" }}>{value}</div>
  </div>
);
